import React, { useState, useEffect } from "react";
import { Form, FormField, Dropdown, Modal, Button } from "semantic-ui-react";
import { showNotification } from "../utils/notifications";

// Format date from ISO to YYYY-MM-DD
function formatDateYMD(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString); // Date() converts date in string
  return date.toISOString().split("T")[0]; // returns in isoformat but only the first element of array, before being split at T character
}

export default function ModaleModifica({
  open,
  onClose,
  user,
  onUpdate,
  readOnly = false,
}) {
  const [formData, setFormData] = useState({
    id: "",
    data_consegna: null,
    codice: "",
    qualifica: "",
    nazionalita: "",
    cognome: "",
    nome: "",
    sesso: "",
    telefono: "",
    citta: "",
    provincia: "",
    cap: "",
    coordinate: "",
    zona: "",
    asl: "",
    municipi_distretti_roma: "",
    email: "",
    patente: "",
    turni_accessi: "",
    data_colloquio_contatto: null,
    offerta_assistenza: "",
    tipo_collaborazione: "",
    commenti: "",
    ultima_modifica: "",
  });

  const opzioniSesso = [
    { key: "n", value: "n", text: "Tutti" },
    { key: "m", value: "m", text: "M" },
    { key: "f", value: "f", text: "F" },
  ];

  const [fieldErrors, setFieldErrors] = useState(true);

  useEffect(() => {
    console.log("Utente ricevuto dal componente modale:", user);
    console.log("tipo di user:", typeof user);
    console.log("Chiavi di user:", user ? Object.keys(user) : "user is null");
    console.log("Valori specifici:");
    if (user) {
      console.log("data_consegna:", user.data_consegna);
      console.log("turni_accessi:", user.turni_accessi);
      console.log("data_colloquio_contatto:", user.data_colloquio_contatto);
      console.log("tipo_collaborazione:", user.tipo_collaborazione);
    }
    if (user) {
      console.log("Dati prima del setState:", {
        ...user,
        sesso: user.sesso ? user.sesso.toLowerCase() : "",
      });

      setFormData({
        ...user,
        sesso: user.sesso ? user.sesso.toLowerCase() : "",
        data_consegna: formatDateYMD(user.data_consegna),
        data_colloquio_contatto: formatDateYMD(user.data_colloquio_contatto),
      });
      console.log("formData aggiornato:", user);
    }
  }, [user]);

  useEffect(() => {
    console.log("formData è cambiato:", formData);
  }, [formData]);

  const handleChange = (e, data) => {
    const { name, value } = data || e.target;

    // rimuovi l'errore quando l'utente inizia a digitare dentro il form
    if (fieldErrors[name]) {
      setFieldErrors({ ...fieldErrors, [name]: false });
    }

    if (
      (name === "data_consegna" || name === "data_colloquio_contatto") &&
      value === ""
    ) {
      setFormData({ ...formData, [name]: null });
    } else {
      setFormData({ ...formData, [name]: value || null });
    }
    console.log("formData dopo handleChange:", { ...formData, [name]: value });
  };

  const handleSubmit = () => {
    // resetta errori precedenti
    setFieldErrors({});

    // verifica campi obbligatori
    const requiredFields = {
      cognome: "Cognome",
      nome: "Nome",
      codice: "Codice Professione",
      telefono: "Telefono",
      citta: "Città",
      provincia: "Provincia",
      cap: "CAP",
      asl: "ASL",
    };
    const errors = {};
    const missingFields = [];

    Object.keys(requiredFields).forEach((field) => {
      if (!formData[field]) {
        errors[field] = true;
        missingFields.push(requiredFields[field]);
      }
    });

    if (missingFields.length > 0) {
      setFieldErrors(errors);
      showNotification(
        `Inserisci i seguenti campi obbligatori: ${missingFields.join(", ")}.`,
        true
      );
      return;
    }

    // get user email from token to record the user who lastly updated record
    const token = localStorage.getItem("auth_token");
    if (token) {
      try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const payload = JSON.parse(window.atob(base64));
        const userEmail = payload.email;

        const updatedData = {
          ...formData,
          ultima_modifica: userEmail,
        };
        console.log("Token decodificato:", payload);
        console.log("Email utente:", userEmail);
        console.log("Dati aggiornati da inviare:", updatedData);
        onUpdate(updatedData);
        onClose();
      } catch (error) {
        console.error("Errore nel decodificare il token:", error);
        onUpdate(formData);
        onClose();
      }
    } else {
      onUpdate(formData);
      onClose();
    }
  };

  if (!user) {
    return null; // se l'utente non è definito, non mostriamo nulla
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={readOnly ? "readonly-modal" : ""}
    >
      <Modal.Header>
        {readOnly ? "Dettaglio Operatore" : "Modifica Operatore"}
      </Modal.Header>
      <Modal.Content>
        <Form className="update-form">
          <FormField disabled>
            <label>ID</label>
            <input
              type="number"
              placeholder="ID"
              name="id"
              value={formData.id || ""}
              onChange={handleChange}
            />
          </FormField>
          <FormField>
            <label>Data Consegna</label>
            <input
              type="date"
              placeholder="Data Consegna"
              name="data_consegna"
              value={formData.data_consegna || ""}
              onChange={handleChange}
              readOnly={readOnly}
            />
          </FormField>
          <FormField disabled={readOnly}>
            <label>Codice</label>
            <Dropdown
              search
              selection
              clearable
              placeholder="Codice"
              name="codice"
              options={[
                { key: "acc", value: "ACC", text: "ACC" },
                { key: "altro", value: "ALTRO", text: "ALTRO" },
                { key: "ammva", value: "AMMVA", text: "AMMVA" },
                { key: "assdom", value: "ASSDOM", text: "ASSDOM" },
                { key: "assfam", value: "ASSFAM", text: "ASSFAM" },
                { key: "asssoc", value: "ASSSOC", text: "ASSSOC" },
                { key: "aus", value: "AUS", text: "AUS" },
                { key: "bad", value: "BAD", text: "BAD" },
                { key: "bio", value: "BIO", text: "BIO" },
                { key: "cuo", value: "CUO", text: "CUO" },
                { key: "die", value: "DIE", text: "DIE" },
                { key: "edu", value: "EDU", text: "EDU" },
                { key: "fsk", value: "FSK", text: "FSK" },
                { key: "igi", value: "IGI", text: "IGI" },
                { key: "inf", value: "INF", text: "INF" },
                { key: "ins", value: "INS", text: "INS" },
                { key: "log", value: "LOG", text: "LOG" },
                { key: "med", value: "MED", text: "MED" },
                { key: "neu", value: "NEU", text: "NEU" },
                { key: "oepac", value: "OEPAC", text: "OEPAC" },
                { key: "ope", value: "OPE", text: "OPE" },
                { key: "ort", value: "ORT", text: "ORT" },
                { key: "osa", value: "OSA", text: "OSA" },
                { key: "oss", value: "OSS", text: "OSS" },
                { key: "osss", value: "OSSS", text: "OSSS" },
                { key: "ost", value: "OST", text: "OST" },
                { key: "ota", value: "OTA", text: "OTA" },
                { key: "pod", value: "POD", text: "POD" },
                { key: "psi", value: "PSI", text: "PSI" },
                { key: "tec", value: "TEC", text: "TEC" },
                { key: "terocc", value: "TEROCC", text: "TEROCC" },
                { key: "tnpee", value: "TNPEE", text: "TNPEE" },
              ]}
              value={formData.codice || ""}
              onChange={handleChange}
              style={
                fieldErrors.codice
                  ? { borderColor: "red", borderWidth: "2px" }
                  : {}
              }
            />
          </FormField>
          <FormField>
            <label>Qualifica</label>
            <input
              type="text"
              placeholder="Qualifica"
              name="qualifica"
              value={formData.qualifica || ""}
              onChange={handleChange}
              readOnly={readOnly}
            />
          </FormField>
          <FormField>
            <label>Nazionalità</label>
            <input
              type="text"
              placeholder="Nazionalita"
              name="nazionalita"
              value={formData.nazionalita || ""}
              onChange={handleChange}
              readOnly={readOnly}
            />
          </FormField>
          <FormField>
            <label>Cognome</label>
            <input
              type="text"
              placeholder="Cognome"
              name="cognome"
              value={formData.cognome || ""}
              onChange={handleChange}
              readOnly={readOnly}
              style={
                fieldErrors.cognome
                  ? { borderColor: "red", borderWidth: "2px" }
                  : {}
              }
            />
          </FormField>
          <FormField>
            <label>Nome</label>
            <input
              type="text"
              placeholder="Nome"
              name="nome"
              value={formData.nome || ""}
              onChange={handleChange}
              readOnly={readOnly}
              style={
                fieldErrors.nome
                  ? { borderColor: "red", borderWidth: "2px" }
                  : {}
              }
            />
          </FormField>
          <FormField disabled={readOnly}>
            <label>Sesso</label>
            <Dropdown
              key="dropdown-sesso"
              selection
              placeholder="Sesso"
              options={opzioniSesso}
              name="sesso"
              value={formData.sesso || ""}
              onChange={handleChange}
            />
          </FormField>
          <FormField>
            <label>Telefono</label>
            <input
              type="tel"
              placeholder="Telefono"
              name="telefono"
              value={formData.telefono || ""}
              onChange={handleChange}
              readOnly={readOnly}
              style={
                fieldErrors.telefono
                  ? { borderColor: "red", borderWidth: "2px" }
                  : {}
              }
            />
          </FormField>
          <FormField>
            <label>Citta</label>
            <input
              type="text"
              placeholder="Citta"
              name="citta"
              value={formData.citta || ""}
              onChange={handleChange}
              readOnly={readOnly}
              style={
                fieldErrors.citta
                  ? { borderColor: "red", borderWidth: "2px" }
                  : {}
              }
            />
          </FormField>
          <FormField>
            <label>Provincia</label>
            <input
              type="text"
              placeholder="Provincia"
              name="provincia"
              value={formData.provincia || ""}
              onChange={handleChange}
              readOnly={readOnly}
              style={
                fieldErrors.provincia
                  ? { borderColor: "red", borderWidth: "2px" }
                  : {}
              }
            />
          </FormField>
          <FormField>
            <label>Cap</label>
            <input
              type="number"
              placeholder="Cap"
              name="cap"
              value={formData.cap || ""}
              onChange={handleChange}
              readOnly={readOnly}
              style={
                fieldErrors.cap
                  ? { borderColor: "red", borderWidth: "2px" }
                  : {}
              }
            />
          </FormField>
          <FormField>
            <label>Coordinate</label>
            <input
              type="text"
              placeholder="Coordinate"
              name="coordinate"
              value={formData.coordinate || ""}
              onChange={handleChange}
              readOnly={readOnly}
            />
          </FormField>
          <FormField>
            <label>Zona</label>
            <input
              type="text"
              placeholder="Zona"
              name="zona"
              value={formData.zona || ""}
              onChange={handleChange}
              readOnly={readOnly}
            />
          </FormField>
          <FormField>
            <label>ASL</label>
            <input
              type="text"
              placeholder="ASL"
              name="asl"
              value={formData.asl || ""}
              onChange={handleChange}
              readOnly={readOnly}
              style={
                fieldErrors.asl
                  ? { borderColor: "red", borderWidth: "2px" }
                  : {}
              }
            />
          </FormField>
          <FormField>
            <label>Municipi/Distretti Roma</label>
            <input
              type="text"
              placeholder="Munic."
              name="municipi_distretti_roma"
              value={formData.municipi_distretti_roma || ""}
              onChange={handleChange}
              readOnly={readOnly}
            />
          </FormField>
          <FormField>
            <label>Email</label>
            <input
              type="email"
              placeholder="Email"
              name="email"
              value={formData.email || ""}
              onChange={handleChange}
              readOnly={readOnly}
            />
          </FormField>
          <FormField disabled={readOnly}>
            <label>Patente</label>
            <Dropdown
              selection
              clearable
              upward
              placeholder="Patente"
              name="patente"
              options={[
                { key: "si", value: "SI", text: "SI" },
                { key: "no", value: "NO", text: "NO" },
              ]}
              value={formData.patente || ""}
              onChange={handleChange}
            />
          </FormField>
          <FormField disabled={readOnly}>
            <label>Disponibilità</label>
            <Dropdown
              selection
              search
              clearable
              upward
              placeholder="Disponibilità"
              name="turni_accessi"
              options={[
                { key: "contattare", value: "CONTATTARE", text: "CONTATTARE" },
                { key: "diurno", value: "DIURNO", text: "DIURNO" },
                { key: "h24", value: "H24", text: "H24" },
                { key: "mattino", value: "MATTINO", text: "MATTINO" },
                { key: "nessuna", value: "NESSUNA", text: "NESSUNA" },
                { key: "notti", value: "NOTTI", text: "NOTTI" },
                { key: "pomeriggio", value: "POMERIGGIO", text: "POMERIGGIO" },
                {
                  key: "posticipare",
                  value: "POSTICIPARE",
                  text: "POSTICIPARE",
                },
                {
                  key: "ricontattabile",
                  value: "RICONTATTABILE",
                  text: "RICONTATTABILE",
                },
                { key: "totale", value: "TOTALE", text: "TOTALE" },
                { key: "turni", value: "TURNI", text: "TURNI" },
                { key: "valutare", value: "VALUTARE", text: "VALUTARE" },
                { key: "weekend", value: "WEEKEND", text: "WEEKEND" },
              ]}
              value={formData.turni_accessi || ""}
              onChange={handleChange}
            />
          </FormField>
          <FormField>
            <label>Data Colloquio Contatto</label>
            <input
              type="date"
              placeholder="Data Colloquio Contatto"
              name="data_colloquio_contatto"
              value={formData.data_colloquio_contatto || ""}
              onChange={handleChange}
              readOnly={readOnly}
            />
          </FormField>
          <FormField>
            <label>Offerta Assistenza</label>
            <input
              type="text"
              placeholder="Offerta Assistenza"
              name="offerta_assistenza"
              value={formData.offerta_assistenza || ""}
              onChange={handleChange}
              readOnly={readOnly}
            />
          </FormField>
          <FormField disabled={readOnly}>
            <label>Tipo Collaborazione</label>
            <Dropdown
              search
              selection
              clearable
              upward
              placeholder="Tipo Collaborazione"
              options={[
                { key: "pub", value: "PUB", text: "PUB" },
                { key: "piva", value: "PIVA", text: "PIVA" },
                { key: "ccnl", value: "CCNL", text: "CCNL" },
                { key: "ass", value: "ASS", text: "ASS" },
                { key: "priv", value: "PRIV", text: "PRIV" },
                { key: "naspi", value: "NASPI", text: "NASPI" },
                { key: "col", value: "COL", text: "COL" },
              ]}
              name="tipo_collaborazione"
              value={formData.tipo_collaborazione || ""}
              onChange={handleChange}
            />
          </FormField>
          <FormField>
            <label>Commenti</label>
            <textarea
              placeholder="Commenti"
              name="commenti"
              value={formData.commenti || ""}
              onChange={handleChange}
              readOnly={readOnly}
              cols={48}
              rows={8}
              style={{ resize: "both" }}
            />
          </FormField>
          <FormField disabled>
            <label>Ultima modifica da:</label>
            <input
              type="text"
              name="ultima_modifica"
              value={formData.ultima_modifica || ""}
            />
          </FormField>
          <FormField disabled>
            <label>Creato da:</label>
            <input
              type="text"
              name="utente_primo_caricamento"
              value={formData.utente_primo_caricamento || ""}
            />
          </FormField>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>{readOnly ? "Chiudi" : "Annulla"}</Button>
        {!readOnly && (
          <Button primary onClick={handleSubmit}>
            Salva
          </Button>
        )}
      </Modal.Actions>
    </Modal>
  );
}
